/* eslint-disable max-len */

export const roofTypes = [
  {
    id: 1,
    label: 'Roof Type',
    title: 'Asphalt Shingles',
    url: '/productImgs/rooftype/Asphalt Shingles.jpg',
    atText: 'altText',
    tag: 'Asphalt Shingles'
  },
  {
    id: 2,
    label: 'Roof Type',
    title: 'Cedar Shingles',
    url: '/productImgs/rooftype/Cedar Shingles.jpg',
    atText: 'altText',
    tag: 'Cedar Shingles'
  },
  {
    id: 111,
    label: 'Roof Type',
    title: 'Concrete/Clay Tile',
    url: '/productImgs/rooftype/ConcreteClay Tile.png',
    tag: 'Concrete/Clay Tile'
  },
  {
    id: 3,
    label: 'Roof Type',
    title: 'Corrugated Metal',
    url: `/productImgs/rooftype/Metal-Corrugated(7by8''-21by2'').jpg`,
    atText: 'altText',
    tag: 'Corrugated Metal'
  },
  {
    id: 304,
    label: 'Roof Type',
    title: 'Flat Seam Metal',
    url: `/productImgs/rooftype/flat Seam 2.jpg`,
    atText: 'altText',
    tag: 'Flat Seam Metal'
  },
  {
    id: 4,
    label: 'Roof Type',
    title: 'Metal Panel',
    url: '/productImgs/rooftype/Metal Panel.jpg',
    atText: 'altText',
    tag: 'Metal Panel'
  },
  {
    id: 5,
    label: 'Roof Type',
    title: 'Metal Shingles',
    url: '/productImgs/rooftype/Metal Shingles.jpg',
    atText: 'altText',
    tag: 'Metal Shingles'
  },
  {
    id: 175,
    label: 'Roof Type',
    title: 'Membrane',
    url: '/productImgs/rooftype/Membrane.jpg',
    atText: 'altText',
    tag: 'Membrane'
  },
  {
    id: 176,
    label: 'Roof Type',
    title: 'Simulated Shake',
    url: '/productImgs/rooftype/Simulated Shake.jpg',
    atText: 'altText',
    tag: 'Simulated Shake'
  },
  {
    id: 6,
    label: 'Roof Type',
    title: 'Simulated Slate',
    url: '/productImgs/rooftype/Simulated Slate.jpeg',
    atText: 'altText',
    tag: 'Simulated Slate'
  },
  {
    id: 7,
    label: 'Roof Type',
    title: 'Slate',
    url: '/productImgs/rooftype/Slate.jpg',
    atText: 'altText',
    tag: 'Slate'
  },
  {
    id: 8,
    label: 'Roof Type',
    title: 'Standing Seam',
    url: '/productImgs/rooftype/Standing Seam.jpg',
    atText: 'altText',
    tag: 'Standing Seam'
  },
  {
    id: 9,
    label: 'Roof Type',
    title: 'Wood Shakes',
    url: '/productImgs/rooftype/dolomites-wood hsakes.jpg',
    atText: 'altText',
    tag: 'Wood Shakes'
  }
];

export const materialData = [
  {
    id: 64,
    label: 'Snow Bracket Material',
    title: 'Steel',
    url: '/productImgs/material/Steel.jpeg',
    atText: 'altText',
    tag: 'Steel'
  },
  {
    id: 65,
    label: 'Snow Bracket Material',
    title: 'Copper',
    url: '/productImgs/material/copper-plating-services-aerospace.jpg',
    atText: 'altText',
    tag: 'Copper'
  },
  {
    id: 66,
    label: 'Snow Bracket Material',
    title: 'Aluminum',
    url: '/productImgs/material/aluminum.jpg',
    atText: 'altText',
    tag: 'Aluminum'
  }
];

export const snowBracketsData = [
  {
    id: 17,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket L',
    url: '/productImgs/Snow-Bracket-L.jpg',
    iconUrl: '/productIcons/Snow-Bracket-L.png',
    atText: 'altText',
    tag: 'Snow Bracket L',
    link: 'https://trasnowandsun.com/product/snow-bracket-l/',
    materials: [{ materialId: 3, material: 'aluminum', price: 0 }]
  },
  {
    id: 18,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket S',
    url: '/productImgs/Snow-Bracket-S.jpg',
    iconUrl: '/productIcons/Snow-Bracket-S.png',
    atText: 'altText',
    tag: 'Snow Bracket S',
    link: 'https://trasnowandsun.com/product/snow-bracket-s/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 188,
    label: 'Snow Bracket Type',
    title: 'Universal Guard',
    url: '/productImgs/Universal-Guard-snow-bracket-1.jpg', // to be replaced with original image
    iconUrl: '/productIcons/Universal-Guard-snow-bracket-1.png', // to be replaced with original icon
    atText: 'altText',
    tag: 'Universal Guard',
    // link: 'https://trasnowandsun.com/product/snow-bracket-s/', // to be replaced with original link
    materials: [{ materialId: 1, material: 'Aluminum', price: 0 }]
  },
  {
    id: 34,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket C (Mushroom)',
    url: '/productImgs/Snow-Bracket-C-Mushroom.jpg',
    iconUrl: '/productIcons/Snow-Bracket-C-Mushroom.png',
    atText: 'altText',
    tag: 'Snow Bracket C (Mushroom)',
    link: 'https://trasnowandsun.com/product/snow-bracket-c-mushroom/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 35,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket A - Apex',
    url: '/productImgs/Snow-Bracket-A-Apex.jpg',
    iconUrl: '/productIcons/Snow-Bracket-A-Apex.png',
    atText: 'altText',
    tag: 'Snow Bracket A - Apex',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 36,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket B - Apex',
    url: '/productImgs/Snow-Bracket-A-Apex.jpg',
    iconUrl: '/productIcons/Snow-Bracket-B-Apex.png',
    atText: 'altText',
    tag: 'Snow Bracket B - Apex',
    link: 'https://trasnowandsun.com/wp-content/uploads/Snow-Bracket-B-Apex.jpg',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 37,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket A/CB - Apex',
    url: '/productImgs/Snow_Bracket_-A-CB_-Apex.jpg',
    iconUrl: '/productIcons/Snow_Bracket_-A-CB_-Apex.png',
    atText: 'altText',
    tag: 'Snow Bracket A/CB - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-a-cb-counter-batten-apex/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 38,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket B/CB - Apex',
    url: '/productImgs/Snow_Bracket_-A-CB_-Apex.jpg',
    iconUrl: '/productIcons/Snow_Bracket_-A-CB_-Apex.png',
    atText: 'altText',
    tag: 'Snow Bracket B/CB - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-b-cb-counter-batten-apex/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 39,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket D - Apex',
    url: '/productImgs/Apex-Snow-Bracket-D.jpg',
    iconUrl: '/productIcons/Apex-Snow-Bracket-D.png',
    atText: 'altText',
    tag: 'Snow Bracket D - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-d-apex/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 40,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket F - Apex',
    url: '/productImgs/Snow-Bracket-F-Apex.png',
    iconUrl: '/productImgs/Snow-Bracket-F-Apex.png',
    atText: 'altText',
    tag: 'Snow Bracket F - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-f-apex/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 41,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket F (Extended) - Apex',
    url: '/productImgs/Apex-Bracket-F-Ex.jpg',
    iconUrl: '/productIcons/Apex-Bracket-F-Ex.png',
    atText: 'altText',
    tag: 'Snow Bracket F (Extended) - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-f-extended-apex/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 42,
    label: 'Snow Bracket Type',
    title: 'Legendary Bracket - Apex',
    url: '/productImgs/Apex-Bracket-Legendary.jpg',
    iconUrl: '/productIcons/Apex-Bracket-Legendary.png',
    atText: 'altText',
    tag: 'Legendary Bracket - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-legendary-apex/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },

  {
    id: 44,
    label: 'Snow Bracket Type',
    title: 'Ludowici-Hook-French - Apex',
    url: '/productImgs/Apex-Bracket-Ludowici-Interlocking-Profile.jpg',
    iconUrl: '/productIcons/Apex-Bracket-Ludowici-Interlocking-Profile.png',
    atText: 'altText',
    tag: 'Ludowici-Hook-French - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-ludowici-interlocking-apex/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 45,
    label: 'Snow Bracket Type',
    title: 'Ludowici-Deck - Apex',
    url: '/productImgs/Apex-Bracket-Ludowici-Mid-Profile.jpg',
    iconUrl: '/productIcons/Apex-Bracket-Ludowici-Mid-Profile.png',
    atText: 'altText',
    tag: 'Ludowici-Deck - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-ludowici-mid-profile-apex/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 43,
    label: 'Snow Bracket Type',
    title: 'Ludowici-Ext Deck-18" Spanish - Apex',
    url: '/productImgs/Apex-Bracket-Ludowici-High-Profile.jpg',
    iconUrl: '/productIcons/Apex-Bracket-Ludowici-High-Profile.png',
    atText: 'altText',
    tag: 'Ludowici-Ext Deck-18" Spanish - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-ludowici-high-profile-apex/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 47,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket H - Apex',
    url: '/productImgs/Snow-Bracket-H-Apex.jpg',
    iconUrl: '/productIcons/Snow-Bracket-H-Apex.png',
    atText: 'altText',
    tag: 'Snow Bracket H - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-h-apex/',
    materials: [
      { materialId: 1, material: 'copper', price: 0 },
      { materialId: 1, material: 'copper', price: 0 }
    ]
  },
  {
    id: 48,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket I (Valley) - Apex',
    url: '/productImgs/Snow_Bracket_I_Valley_Apex.jpg',
    iconUrl: '/productIcons/Snow_Bracket_I_Valley_Apex.png',
    atText: 'altText',
    tag: 'Snow Bracket I (Valley) - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-i-valley-apex/',
    materials: [{ materialId: 2, material: 'steel', price: 0 }]
  },
  {
    id: 50,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket I (Crest) - Apex',
    url: '/productImgs/Snow-Bracket-I-Crest-Apex.jpg',
    iconUrl: '/productIcons/Snow-Bracket-I-Crest-Apex.png',
    atText: 'altText',
    tag: 'Snow Bracket I (Crest) - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-i-crest-apex/',
    materials: [{ materialId: 2, material: 'steel', price: 0 }]
  },
  {
    id: 56,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket G 9.5 - Apex',
    url: '/productImgs/Apex-Bracket-G-9.5.jpg',
    iconUrl: '/productIcons/Apex-Bracket-G-9.5.png',
    atText: 'altText',
    tag: 'Snow Bracket G 9.5 - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-g-9-5-apex/',
    materials: [{ materialId: 1, material: 'copper', price: 0 }]
  },
  {
    id: 57,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket G 11.5 - Apex',
    url: '/productImgs/Apex-Bracket-G-11.5.jpg',
    iconUrl: '/productIcons/Apex-Bracket-G-11.5.png',
    atText: 'altText',
    tag: 'Snow Bracket G 11.5 - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-g-11-5-apex/',
    materials: [{ materialId: 1, material: 'copper', price: 0 }]
  },
  {
    id: 59,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket C (Bear)',
    url: '/productImgs/Snow-Bracket-C-Bear.jpg',
    iconUrl: '/productIcons/Snow-Bracket-C-Bear.png',
    atText: 'altText',
    tag: 'Snow Bracket C (Bear)',
    link: 'https://trasnowandsun.com/product/snow-bracket-c-bear/',
    materials: [{ materialId: 2, material: 'steel', price: 0 }]
  },
  {
    id: 60,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket C (Tree)',
    url: '/productImgs/Snow-Bracket-c-t.jpg',
    iconUrl: '/productIcons/Snow-Bracket-c-t.png',
    atText: 'altText',
    tag: 'Snow Bracket C (Tree)',
    link: 'https://trasnowandsun.com/product/snow-bracket-c-tree/',
    materials: [{ materialId: 2, material: 'steel', price: 0 }]
  },
  {
    id: 61,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket C (Moose)',
    url: '/productImgs/Snow-Bracket-c-m.jpg',
    iconUrl: '/productIcons/Snow-Bracket-c-m.png',
    atText: 'altText',
    tag: 'Snow Bracket C (Moose)',
    link: 'https://trasnowandsun.com/product/snow-bracket-c-moose/',
    materials: [{ materialId: 2, material: 'steel', price: 0 }]
  },
  {
    id: 170,
    label: 'Snow Bracket Type',
    title: 'SnowBlocker 1',
    url: '/productImgs/Snow-Blocker-1-Rail.jpg',
    iconUrl: '/productIcons/fence/Snow-Blocker-1-Rail.png',
    atText: 'altText',
    tag: 'SnowBlocker 1',
    link: 'https://trasnowandsun.com/product/snow-blocker-1-deck-mount-snow-fence/',
    materials: [{ materialId: 2, material: 'steel', price: 0 }]
  },
  {
    id: 171,
    label: 'Snow Bracket Type',
    title: 'SnowBlocker 2',
    url: '/productImgs/Snow-Blocker-2-Rail.jpg',
    iconUrl: '/productIcons/fence/Snow-Blocker-2-Rail.png',
    atText: 'altText',
    tag: 'SnowBlocker 1',
    link: 'https://trasnowandsun.com/product/snow-blocker-2-deck-mount-snow-fence/',
    materials: [{ materialId: 2, material: 'steel', price: 0 }]
  },
  {
    id: 172,
    label: 'Snow Bracket Type',
    title: 'SnowBlocker 3',
    url: '/productImgs/Snow-Blocker-3-Rail.jpg',
    iconUrl: '/productIcons/fence/Snow-Blocker-1-Rail.png',
    atText: 'altText',
    tag: 'SnowBlocker 1',
    link: 'https://trasnowandsun.com/product/snow-blocker-3-deck-mount-snow-fence/',
    materials: [{ materialId: 2, material: 'steel', price: 0 }]
  },
  {
    id: 172,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket Slate Hook - Apex',
    url: '/productImgs/Apex Bracket Slate Hook.png',
    iconUrl: '/productImgs/Apex Bracket Slate Hook.png',
    atText: 'altText',
    tag: 'Snow Bracket Slate Hook - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-slate-hook-apex/',
    materials: [{ materialId: 2, material: 'steel', price: 0 }]
  },
  {
    id: 173,
    label: 'Snow Bracket Type',
    title: 'Snow Bracket J - Apex',
    url: '/productImgs/Apex-Bracket-J.jpg',
    iconUrl: '/productImgs/Apex-Bracket-J.jpg',
    atText: 'Snow Bracket J - Apex',
    tag: 'Snow Bracket J - Apex',
    link: 'https://trasnowandsun.com/product/snow-bracket-j-apex/',
    materials: [{ materialId: 2, material: 'steel', price: 0 }]
  }
];

export const fasteners = [
  {
    id: 67,
    label: 'Fastener Type',
    title: '#8 Screws',
    url: '/productImgs/fastner/Stainless-Steel-hash8-Screws.jpg',
    atText: 'altText',
    tag: '#8 Screws'
  },
  {
    id: 68,
    label: 'Fastener Type',
    title: 'Roofing Nails',
    url: '/productImgs/fastner/Roofing Nails.jpg',
    atText: 'altText',
    tag: 'Roofing Nails'
  },
  {
    id: 69,
    label: 'Fastener Type',
    title: 'Stainless Steel #8 Screws',
    url: '/productImgs/fastner/Stainless-Steel-hash8-Screws-closeup.jpg',
    atText: 'altText',
    tag: 'Stainless Steel #8 Screws'
  },
  {
    id: 70,
    label: 'Fastener Type',
    title: '#14 Screws',
    url: '/productImgs/fastner/hash 14 Screws.jpg',
    atText: 'altText',
    tag: '#14 Screws'
  },
  {
    id: 71,
    label: 'Fastener Type',
    title: 'Stainless Steel #14 Screws',
    url: '/productImgs/fastner/Stainless Steel hash 14 Screws.jpg',
    atText: 'altText',
    tag: 'Stainless Steel #14 Screws'
  },
  {
    id: 72,
    label: 'Fastener Type',
    title: '16D Galvanized Nails',
    url: '/productImgs/fastner/16D Galvanized Nails.webp',
    atText: 'altText',
    tag: '16D Galvanized Nails'
  },
  {
    id: 822,
    label: 'Fastener Type',
    title: 'Tile Hook',
    url: '/productImgs/placeholder.png',
    atText: 'altText',
    tag: 'Tile Hook'
  },
  {
    id: 822,
    label: 'Fastener Type',
    title: '3/16 Screws',
    url: '/productImgs/fastner/3-16-in-Screw.jpg',
    atText: 'altText',
    tag: '3/16 Screws'
  }
];

export const imgsData = [
  // Roof Type
  ...roofTypes,
  // Construction Type
  {
    id: 10,
    label: 'Construction Type',
    title: 'New Construction',
    url: '/productImgs/construction/gettyimages-new Construction.jpg',
    atText: 'altText',
    tag: 'New Construction'
  },
  {
    id: 11,
    label: 'Construction Type',
    title: 'Retrofit',
    url: '/productImgs/construction/Metal-roof-retrofit.jpg',
    atText: 'altText',
    tag: 'Retrofit'
  },
  // Snow Bracket Type
  ...snowBracketsData,
  // Snow Bracket Material
  ...materialData,
  // Fastener Type
  ...fasteners,
  // Sheathing
  {
    id: 73,
    label: 'Sheathing',
    title: '7/16 PLY',
    url: '/productImgs/sheathing/7by16 ply.jpeg',
    atText: 'altText',
    tag: '7/16 PLY'
  },
  {
    id: 74,
    label: 'Sheathing',
    title: '7/16 OSB',
    url: '/productImgs/sheathing/5by8OSB-Product-Image.jpeg',
    atText: 'altText',
    tag: '7/16 OSB'
  },
  {
    id: 75,
    label: 'Sheathing',
    title: '1/2 PLY',
    url: '/productImgs/sheathing/7by16 ply.jpeg',
    atText: 'altText',
    tag: '1/2 PLY'
  },
  {
    id: 76,
    label: 'Sheathing',
    title: '1/2 OSB',
    url: '/productImgs/sheathing/5by8OSB-Product-Image.jpeg',
    atText: 'altText',
    tag: '1/2 OSB'
  },
  {
    id: 77,
    label: 'Sheathing',
    title: '5/8 PLY',
    url: '/productImgs/sheathing/7by16 ply.jpeg',
    atText: 'altText',
    tag: '5/8 PLY'
  },
  {
    id: 78,
    label: 'Sheathing',
    title: '5/8 OSB',
    url: '/productImgs/sheathing/5by8OSB-Product-Image.jpeg',
    atText: 'altText',
    tag: '5/8 OSB'
  },
  {
    id: 79,
    label: 'Sheathing',
    title: '3/4 PLY',
    url: '/productImgs/sheathing/7by16 ply.jpeg',
    atText: 'altText',
    tag: '3/4 PLY'
  },
  {
    id: 80,
    label: 'Sheathing',
    title: '3/4 OSB',
    url: '/productImgs/sheathing/5by8OSB-Product-Image.jpeg',
    atText: 'altText',
    tag: '3/4 OSB'
  },
  // no images, use placeholder for Manufacturers
  {
    id: 81,
    label: 'Manufacturer',
    title: 'Eagle',
    url: '/productImgs//Tile Manufacturer/Eagle Logo.png',
    atText: 'altText',
    tag: 'Eagle'
  },
  // {
  //   id: 82,
  //   label: 'Manufacturer',
  //   title: 'Hanson',
  //   url: '/productImgs/placeholder.png',
  //   atText: 'altText',
  //   tag: 'Hanson'
  // },
  // {
  //   id: 83,
  //   label: 'Manufacturer',
  //   title: 'Westile',
  //   url: '/productImgs/placeholder.png',
  //   atText: 'altText',
  //   tag: 'Westile'
  // },
  // {
  //   id: 84,
  //   label: 'Manufacturer',
  //   title: 'Unicrete',
  //   url: '/productImgs/placeholder.png',
  //   atText: 'altText',
  //   tag: 'Unicrete'
  // },
  // {
  //   id: 85,
  //   label: 'Manufacturer',
  //   title: 'Columbia',
  //   url: '/productImgs/placeholder.png',
  //   atText: 'altText',
  //   tag: 'Columbia'
  // },
  // {
  //   id: 86,
  //   label: 'Manufacturer',
  //   title: 'Entegra',
  //   url: '/productImgs/placeholder.png',
  //   atText: 'altText',
  //   tag: 'Entegra'
  // },
  // {
  //   id: 87,
  //   label: 'Manufacturer',
  //   title: 'Monier-Lifetile',
  //   url: '/productImgs/placeholder.png',
  //   atText: 'altText',
  //   tag: 'Monier-Lifetile'
  // },
  {
    id: 88,
    label: 'Manufacturer',
    title: 'Vande Hey-Raleigh',
    url: '/productImgs//Tile Manufacturer/vande-hay.jpg',
    atText: 'altText',
    tag: 'Vande Hey-Raleigh'
  },
  {
    id: 89,
    label: 'Manufacturer',
    title: 'Bartile',
    url: '/productImgs//Tile Manufacturer/Bartile_logo.jpg',
    atText: 'altText',
    tag: 'Bartile'
  },
  {
    id: 90,
    label: 'Manufacturer',
    title: 'Ludowici',
    url: '/productImgs//Tile Manufacturer/Ludowici.png',
    atText: 'altText',
    tag: 'Ludowici'
  },
  // no images, use placeholder for Installation Methods
  {
    id: 91,
    label: 'Installation Method',
    title: 'Direct to Deck',
    url: '/productImgs/Installation Method/Direct to Deck.jpg',
    atText: 'altText',
    tag: 'Direct to Deck'
  },
  {
    id: 92,
    label: 'Installation Method',
    title: 'Horizontal Batten',
    url: '/productImgs/Installation Method/Horizontal Batten.jpg',
    atText: 'altText',
    tag: 'Horizontal Batten'
  },
  {
    id: 93,
    label: 'Installation Method',
    title: 'Elevated Batten',
    url: '/productImgs/Installation Method/Elevated Batten.jpg',
    atText: 'altText',
    tag: 'Elevated Batten'
  },
  {
    id: 94,
    label: 'Installation Method',
    title: 'Counter-Batten/Double-Batten',
    url: '/productImgs/Installation Method/Counter Batten.jpg',
    atText: 'altText',
    tag: 'Counter-Batten/Double-Batten'
  },
  // no images, use placeholder for Mount to
  {
    id: 95,
    label: 'Mount To',
    title: 'Trusses/Rafters',
    url: '/productImgs/placeholder.png',
    atText: 'altText',
    tag: 'Trusses/Rafters'
  }
];
